import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "./styles.scss";
import photo from "../../assets/photos/UNM_HS-Wellness_Art-Walk-6_WEB.jpg";
function SectionTen({ placeholderSrc }) {
  return (
    <div className="tw-bg-secondary">
      <div className="spacer h-[6rem]"></div>
      <div className="tw-relative -tw-secondary-gradient md:tw-px-8 tw-pb-4">
        <div className="sectionNumber tw-absolute tw-font-extrabold xl:tw-text-[11.0rem] xl:tw-leading-[11.0rem] tw-block">
          8
        </div>
        <LazyLoadImage
          alt="The World Within"
          src={photo}
          placeholderSrc={placeholderSrc}
        
        />
      </div>
      <div className="tw-bg-secondary tw-px-8 tw-pb-4">
        <p className="tw-font-bold tw-italic tw-mb-4 tw-text-2xl">
          The World Within
        </p>
        <p>
          his piece by renowned sculptor Arthur Williams calls to mind the
          worlds within worlds we encounter in life. Within the Health Sciences
          Center many inhabit different worlds, as students, staff or faculty.
          This substantial sculpture reminds us that many of them are hatching a
          new world from within, as well.
        </p>
      </div>
    </div>
  );
}

export default SectionTen;
